import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/onboarding/profile')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
